<template>
    <div>
        <b-form-select v-model="data" :options="workPlaces"></b-form-select>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: "WorkPlaceSelect",
        props: {
            value: {type: [Object, String],},
            startAt: null,
            blocked: null
        },
        data() {
            return {}
        },
        computed: {
            ...mapGetters('work-place', {findWorkPlacesInStore: 'find'}),

            workPlaces() {
                let query = {};
                let items = this.findWorkPlacesInStore({query}).data;
                return items.map(el => {
                    let text = el.label;
                    if (this.isBlocked(el._id))
                        text += ' ⚠️';
                    return {value: el._id, text: text}
                })
            },
            data: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                    this.$emit('change', value)
                }
            }
        },
        created() {
            this.fetchWorkPlaces()
        },
        methods: {
            ...mapActions('work-place', {findWorkPlaces: 'find'}),

            isBlocked(workPlaceId) {
                if (!this.blocked) return;
                let startAt = this.$moment(this.startAt);
                return this.blocked.find(el => {
                    let start = this.$moment(el.start);
                    let end = this.$moment(el.end);
                    let sameTime = startAt.isSame(el.start) || (startAt.isAfter(start) && startAt.isBefore(end));
                    return (el.workPlaceId === workPlaceId) && sameTime
                })
            },

            fetchWorkPlaces() {
                let query = {};
                return this.findWorkPlaces({query})
            }
        }
    }
</script>

<style scoped>

</style>
